module.exports = __webpack_public_path__ + "img/oasis.9692be22.png";